import { updateScore, addComment, addOverviewComment } from './handlers';

export default [
  { address: 'essentialScoreboardCallback', handler: updateScore },
  { address: 'overviewComment', handler: addOverviewComment },
  { address: 'comment', handler: addComment, sports: [200] },
];
